import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import api from 'api';
import { province } from 'configs/data';
import link from 'configs/link';
import { track, trackMap } from 'track';
import AreaPicker from './components/AreaPicker';
import IsJoinModal from './components/IsJoinModal';
import SignModal from './components/SignModal';
import ConfirmModal from './components/ConfirmModal';

import {
  Wrap,
  Bg,
  Content,
  TimeBlock,
  InfoBlock,
  BannerWrap,
  Banner,
  FeatureBlock,
  Card,
  ListBtn,
  InquireBlock,
  SignBtn,
  RuleBlock,
  RuleContent,
  AreaTitile,
  AreaText,
  Item,
  GetBtn
} from './Styles';
import Alert from 'components/Alert';

const nameMap = {
  visa: 'Visa',
  master: '万事达'
};

const Home = props => {
  // 选择网点，对应信息
  const [pick, setPick] = useState([]);
  const [data, setData] = useState({
    provinceData: province,
    cityData: [],
    regionData: []
  });
  const [areaInfo, setAreaInfo] = useState([]);
  const [info, setInfo] = useState({});
  const handleAreaPick = async ({ name, next, value, info, data }) => {
    track(trackMap[`落地页_选择${name}`]);
    setPick(value);
    const [province, city, area] = value;
    const [err, res] = await api.postScreen({ province, city, area });
    if (err) return;
    if (info) {
      setInfo(info);
      return;
    }
    if (next !== 'area') {
      setData(s => {
        return { ...data, [next]: res.list };
      });
      setAreaInfo([]);
    } else {
      setAreaInfo(res.list);
    }
  };

  // 点击报名
  const [showSignModal, setShowSignModal] = useState(false);
  const [isJoinModal, setIsJoinModal] = useState({ show: false, mobile: '' });
  const [confirmModal, setConfirmModal] = useState({ show: false, values: {} });
  const [showAlert, setShowAlert] = useState(false);
  const handleSign = async () => {
    // const [err, res] = await api.getJoined();
    // if (err) return;
    // if (res.haveJoined) {
    //   setIsJoinModal({ show: true, mobile: res.mobile });
    // } else {
    //   setShowSignModal(true);
    // }
    setShowAlert(true);
  };

  // 记录跳转路由时页面滚动位置，返回后回到该位置
  const { pathname } = useLocation();
  const ref = useRef();
  useEffect(() => {
    const y = sessionStorage.getItem(pathname);
    ref.current.scrollTo(0, y);
    sessionStorage.removeItem(pathname);
  }, [pathname]);
  const recordScrollTop = () =>
    sessionStorage.setItem(pathname, ref.current.scrollTop);

  // 各种跳转
  const toList = type => {
    recordScrollTop();
    track(trackMap[`落地页_更多${nameMap[type]}`]);
    props.history.replace(`/list?type=${type}`);
  };
  const toCardInfo = type => {
    recordScrollTop();
    track(trackMap[`落地页_${nameMap[type]}卡片`]);
    props.history.replace({
      pathname: '/card',
      search: `?type=${type}&card=0`
    });
  };
  const toDetail = type => {
    recordScrollTop();
    track(trackMap[`落地页_${nameMap[type]}活动`]);
    props.history.replace(`/detail?type=${type}`);
  };

  return (
    <Wrap ref={ref}>
      <Bg />
      <Content>
        <TimeBlock />
        <InfoBlock>
          <GetBtn
            onClick={() => {
              track(trackMap['落地页_汇款优惠']);
              setTimeout(() => {
                window.location.href = link['home'];
              }, 1000);
            }}
          />
        </InfoBlock>
        <BannerWrap>
          <Banner type="master" onClick={() => toDetail('master')} />
          <Banner type="visa" onClick={() => toDetail('visa')} />
        </BannerWrap>
        <SignBtn onClick={handleSign} />
        <FeatureBlock>
          <Card type="master" onClick={() => toCardInfo('master')}></Card>
          <Card type="visa" onClick={() => toCardInfo('visa')}></Card>
          <ListBtn type="master" onClick={() => toList('master')} />
          <ListBtn type="visa" onClick={() => toList('visa')} />
        </FeatureBlock>
        <InquireBlock>
          <AreaPicker
            value={pick}
            data={data}
            areaInfo={areaInfo}
            onChange={opt => handleAreaPick(opt)}
          />
          <AreaTitile>该网点信息</AreaTitile>
          {info.name ? (
            <>
              <AreaText>网点名称：{info.name}</AreaText>
              <AreaText>网点地址：{info.address}</AreaText>
            </>
          ) : (
            <AreaText>尚未选择网点</AreaText>
          )}
        </InquireBlock>
        <RuleBlock>
          <RuleContent width={660} height={340} className="scrollable">
            <div>
              1.本次活动适用于中国银行长城跨境通国际借记卡（下简称“EMV借记卡”）持卡人，其中开卡礼活动仅限在活动期间首次开办EMV借记卡的客户参与。
            </div>
            <div>
              2.本次活动的主要内容包括：境外消费笔笔返现1%、指定黑五商户消费支付返现10%、指定考试网站支付返现20%，以及新客开卡可1美元抢购8美元美国亚马逊消费券（下简称“新客开卡礼”）。其它由卡组织提供的借记卡权益活动，具体内容详见相关卡组织提供的活动详情或卡组织权益平台。
            </div>
            <div>
              3.返现活动规则：
              <br />
              （1）返现交易须通过Visa、万事达卡组织网络进行，使用上述卡组织以外其他支付渠道（如通过支付宝、微信、财付通选择网银支付或快捷支付等方式）、境外预借现金、境外转账、电子现金脱机交易等不参加活动。
              <br />
              （2）返现金额最小单位是0.01元，低于等值1元人民币的交易金额无返现，每个返现活动的额度上限和返现时间详见卡组织活动详情。
              <br />
              （3）交易时间、资格统计时间、入账时间、交易金额及汇率以中国银行系统记录为准。如因卡组织或收单机构原因导致无法识别的境外交易，将不纳入返现统计范围。如遇商户发起的拆单，以拆单后的实际交易金额显示的交易金额为准。
              <br />
              （4）如发生退货、冲正或撤销等交易，将不进行返现，且中国银行保留扣回不符合条件但已返现金额的权利。
              <br />
              （5）如发现有利用活动规则恶意套取返现奖励的客户，中国银行保留取消其参加本次营销活动的权利。
            </div>
            <div>
              4.新客开卡礼活动规则：
              <br />
              （1）活动期间每位持卡人仅限购买一次。
              <br />
              （2）开卡礼中的活动商品为虚拟服务，一经购买成功，概不退换，请在支付前详细阅读相关活动条款。
              <br />
              （3）活动商品只能用于在美国亚马逊网站www.Amazon.com购买合格商品和服务。
            </div>
            <div>
              5.新客开卡礼活动由卡组织合作商户负责运营，如有问题请与相关商户联系，联系电话详见活动页面。
            </div>
            <div>6.本次活动名额有限，符合活动条件的客户先到先得。</div>
            <div>
              7.中国银行将在法律允许的范围内，保留根据需要修订活动相关条款（包括但不限于活动时间、活动内容、活动规则、名额限制等）、暂停或取消本活动的权利，并于中国银行官方网站或其他相关渠道公告后生效。
            </div>
            <div>
              8.本次活动返现所得税由获赠持卡人自理并自行向税务机关申报、缴纳。
            </div>
            <div>9.本次活动其他相关问题，可咨询中国银行客服电话95566。</div>
          </RuleContent>
        </RuleBlock>
      </Content>
      {Array(4)
        .fill('')
        .map((_, idx) => (
          <Item key={idx} type={idx} />
        ))}
      <IsJoinModal
        open={isJoinModal.show}
        mobile={isJoinModal.mobile}
        onClose={() => {
          setIsJoinModal(s => {
            return { ...s, show: false };
          });
          setShowSignModal(false);
        }}
      />
      <ConfirmModal
        open={confirmModal.show}
        values={confirmModal.values}
        onClose={() =>
          setConfirmModal(s => {
            return { ...s, show: false };
          })
        }
        onConfirm={({ mobile }) => {
          setIsJoinModal({ show: true, mobile });
          setConfirmModal(s => {
            return { ...s, show: false };
          });
        }}
      />
      <SignModal
        open={showSignModal}
        onClose={() => setShowSignModal(false)}
        onSuccess={values => {
          setConfirmModal({ show: true, values });
        }}
      />
      <Alert
        open={showAlert}
        text="活动已结束"
        closeTime={2000}
        onClose={() => setShowAlert(false)}
      />
    </Wrap>
  );
};

export default Home;
